module.exports = __webpack_public_path__ + "img/9.efb2f501.svg";